export function isNullOrUndefined(arg: unknown): arg is null | undefined {
  return arg == null || typeof arg === `undefined`;
}
